import React from 'react'
import { Button, Icon, Spin } from 'antd'
import PropTypes from 'prop-types'
import { getDirectionClassName, getLanguageDirection } from './storyDirection'
import './TranslationWorkspace.scss'

const TranslationWorkspace = ({
  existingStory,
  translatedStory,
  translatedStoryLanguage,
  translatedStoryLanguageLabel,
  languageControl,
  isLoading,
  onTranslate,
  onReview,
  onAddStory
}) => {
  const resultDirection = getLanguageDirection(translatedStoryLanguage)
  const resultDirectionClass = getDirectionClassName(resultDirection)

  return (
    <div className="translation-workspace">
      <div className="translation-workspace__grid">
        <div className="translation-workspace__action-step">
          <div className="translation-workspace__action-copy">
            <div className="translation-workspace__action-title">
              <Icon type="swap" /> Generate Translation
            </div>
            <div className="translation-workspace__action-text">
              Choose a language, then translate.
            </div>
          </div>
          <div className="translation-workspace__action-controls">
            <div className="translation-workspace__language-control">
              {languageControl}
            </div>
            <Button
              className="quick-translate-btn"
              type="primary"
              onClick={onTranslate}
              loading={isLoading}
              icon='thunderbolt'
            >
              Translate
            </Button>
          </div>
        </div>
        <div className="translation-panel translation-panel--source" dir="auto">
          <div className="translation-panel__header">
            <div className="translation-panel__header-main">
              <span className="translation-panel__section-icon">
                <Icon type="file-text" />
              </span>
              <span className="title">Original Story</span>
            </div>
          </div>
          <div className="translation-panel__content">{existingStory}</div>
        </div>



        <div className="translation-panel translation-panel--result">
          <div className="translation-panel__header">
            <div className="translation-panel__header-main">
              <span className="translation-panel__section-icon translation-panel__section-icon--accent">
                <Icon type="book" />
              </span>
              <span className="title">Translated Story</span>
            </div>
            {translatedStory && translatedStoryLanguage && (
              <span className="translation-panel__pill">
                {translatedStoryLanguageLabel}
              </span>
            )}
          </div>

          {isLoading ? (
            <div className="translation-state translation-state--loading">
              <Spin size="large" />
              <div className="translation-state__title">Translating story...</div>
              <div className="translation-state__text">
                We&apos;re generating the translated version now.
              </div>
            </div>
          ) : translatedStory ? (
            <div
              className={`translation-panel__result-body ${resultDirectionClass}`}
              dir={resultDirection}
            >
              <div className="translation-panel__content translation-panel__content--result">
                {translatedStory}
              </div>
              <div className="translation-panel__footer">
                <Button
                  type="default"
                  className="review-edit-btn"
                  onClick={onReview}
                >
                  <Icon type="edit" /> Review & Edit
                </Button>
                <Button
                  type="primary"
                  className="add-to-video-btn"
                  onClick={onAddStory}
                >
                  <Icon type="thunderbolt" /> Add to Video
                </Button>
              </div>
            </div>
          ) : (
            <div className="translation-state translation-state--empty">
              <Icon type="translation" />
              <div className="translation-state__title">Ready to translate</div>
              <div className="translation-state__text">
                Generate a translated version to preview it here.
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

TranslationWorkspace.propTypes = {
  existingStory: PropTypes.string,
  translatedStory: PropTypes.string,
  translatedStoryLanguage: PropTypes.string,
  translatedStoryLanguageLabel: PropTypes.string,
  languageControl: PropTypes.node,
  isLoading: PropTypes.bool,
  onTranslate: PropTypes.func,
  onReview: PropTypes.func,
  onAddStory: PropTypes.func
}

TranslationWorkspace.defaultProps = {
  existingStory: '',
  translatedStory: '',
  translatedStoryLanguage: '',
  translatedStoryLanguageLabel: 'English',
  languageControl: null,
  isLoading: false,
  onTranslate: null,
  onReview: null,
  onAddStory: null
}

export default TranslationWorkspace
